import { useContext } from "react";
import { PageContext } from "../contexts/PageContext";
import { useParams } from "react-router-dom";
import { Box, useTheme } from "@mui/material";
import WorldEditPanel from "../panels/WorldEditPanel";

export function SitesView() {
  const { siteId } = useParams<{ siteId: string }>();
  const theme = useTheme();
  const { isLoggedIn, user } = useContext(PageContext);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        backgroundColor: theme.palette.background.default,
        color: "#ECECEC",
        overflow: "hidden",
        px: 0, // Padding shorthand
        py: 0, // Padding shorthand
      }}
    >
      <WorldEditPanel
        heightOffset={0}
        activeSiteId={siteId === 'all' ? '' : (siteId || 'new')}
        rendererKey={Date.now().toString()}
      />
    </Box>
  );
}
